<div *ngIf="isLoading">
    <div
        class="skeleton-loader"
        aria-busy="true"
        [class.skeleton-loader-table]="
            context.layout === 'table' ||
            (context.layout === 'vertical' &&
                context.widgetId !== 'account-balance-filtered')
        "
        [class.skeleton-loader-fill]="
            context.layout === 'horisontal' ||
            context.widgetId === 'account-balance-filtered'
        "
        [style.height]="context.layout === 'horisontal' ? '3rem' : null"
    ></div>
</div>
<app-sb-widget-button-bar
    *ngIf="context.buttons"
    [buttons]="context.buttons"
    [data]="dataElements | toFlatObjectModel"
></app-sb-widget-button-bar>
<!-- Horizontal key figure layout -->
<ng-container *ngIf="showMarketValueOverTime === false">
    <div
        *ngIf="context.layout === 'horisontal'"
        style="display: flex; justify-content: flex-end"
    >
        <ng-container class="right">
            <button
                type="button"
                class="btn btn-link text-primary"
                style="position: absolute; top: -3rem; right: 0"
                [matMenuTriggerFor]="horizontalLayoutContextMenu"
            >
                <tabler-icon name="dots"></tabler-icon>
            </button>
            <mat-menu #horizontalLayoutContextMenu="matMenu">
                <button
                    type="button"
                    class="d-inline-flex align-items-center"
                    mat-menu-item
                    (click)="toggleShortNumberFormat()"
                >
                    <tabler-icon
                        class="me-2"
                        style="height: 20px; width: 20px; display: inline-flex"
                        [name]="useShortNumberFormat ? 'error-404-off' : '123'"
                    ></tabler-icon>
                    {{
                        useShortNumberFormat ? 'Use regular numbers' : 'Use short numbers'
                    }}
                </button>
            </mat-menu>
        </ng-container>
    </div>
    <div
        *ngIf="context.layout === 'horisontal'"
        class="sb-horizontal-key-figure-advanced-wrapper"
    >
        <ng-container *ngFor="let element of dataElements">
            <div *ngIf="element.hidden != true">
                <div class="col">
                    <div
                        [ngClass]="element.labelClass"
                        [ngStyle]="element.labelInlineStyle"
                    >
                        {{ element.key }}
                    </div>
                    <ng-container
                        *ngFor="let elementValue of element.values; let i = index"
                    >
                        <span
                            *ngIf="elementValue.hidden != true"
                            [ngClass]="elementValue.valueClass"
                            [ngStyle]="elementValue.valueInlineStyle"
                        >
                            <span *ngIf="isObject(elementValue.value)">
                                <app-sb-advanced-cell
                                    [context]="context"
                                    [value]="elementValue.value"
                                    [columnConfiguration]="getColumnConfiguration()"
                                    [defaultAlignment]="getDefaultAlignment(i)"
                                ></app-sb-advanced-cell>
                            </span>
                            <span *ngIf="!isObject(elementValue.value)">
                                <ng-container
                                    *ngIf="useShortNumberFormat; else normalValue"
                                >
                                    {{
                                        elementValue.value
                                            | formatDecider : elementValue.rawValue : true
                                            | async
                                    }}
                                </ng-container>
                                <ng-template #normalValue>
                                    {{ elementValue.value }}
                                </ng-template>
                            </span>
                        </span>
                    </ng-container>
                </div>
            </div>
        </ng-container>
    </div>
</ng-container>
<!-- Table key figure layout -->
<div *ngIf="context.layout === 'vertical'" class="sb-key-figure-advanced-wrapper">
    <ng-container [ngSwitch]="context.widgetId">
        <ng-container *ngSwitchCase="'account-balance-filtered'">
            <ng-container *ngIf="dataElements?.length > 0">
                <ng-container *ngIf="groupData$ | async as groupData">
                    <ng-container *ngIf="dataElements | sbGroupAccounts as accountGroup">
                        <dl class="sb-group">
                            <div class="sb-group-thumbnail">
                                <sb-company-logo
                                    *ngIf="!groupData?.icon; else accountIcon"
                                    [companyWebsite]="groupData?.website"
                                    [companyLogoUrl]="groupData?.logoUrl"
                                    [countryCode]="groupData?.countryCode | countryCode"
                                    [type]="groupData?.icon"
                                    size="lg"
                                ></sb-company-logo>
                                <ng-template #accountIcon>
                                    <div class="sb-account-icon rounded">
                                        <tabler-icon
                                            class="sb-icon-md"
                                            [name]="groupData?.icon"
                                        ></tabler-icon>
                                    </div>
                                </ng-template>
                            </div>
                            <dt class="sb-group-name">
                                {{ groupData?.displayName }}
                            </dt>
                            <dd class="sb-group-details">
                                <span *ngIf="accountGroup.data.length > 1">
                                    Number of accounts: {{ accountGroup.data?.length }}
                                </span>
                                <span
                                    *ngIf="
                                        accountGroup.data.length === 1 &&
                                        groupData?.accountNumber
                                    "
                                >
                                    {{ groupData?.accountNumber }}
                                </span>
                            </dd>
                            <dd class="sb-group-balance">
                                <sb-animated-number
                                    [ccy]="accountGroup.baseCurrency"
                                    [useMonotypeFont]="false"
                                    [value]="accountGroup.totalMarketValue.real"
                                ></sb-animated-number>
                            </dd>
                            <dd
                                class="sb-group-performance d-inline-flex align-items-center justify-content-end text-nowrap"
                                *ngIf="
                                    accountGroup.relativeDailyPerformance as performance
                                "
                            >
                                Daily&nbsp;
                                <span
                                    style="display: contents"
                                    [class.text-positive]="performance > 0"
                                    [class.text-negative]="performance < 0"
                                >
                                    <tabler-icon
                                        style="height: 18px; width: 18px"
                                        name="circle-arrow-up"
                                        [class.sb-transform-r90]="performance === 0"
                                        [class.sb-transform-r45]="performance > 0"
                                        [class.sb-transform-r135]="performance < 0"
                                        class="me-1 tabler-fill-circle sb-transform-animate sb-icon-sm"
                                    ></tabler-icon>
                                    <sb-animated-number
                                        class="font-weight-medium"
                                        [useMonotypeFont]="false"
                                        formatStyle="percent"
                                        [value]="performance"
                                    ></sb-animated-number>
                                </span>
                            </dd>
                        </dl>
                        <sb-list-sub-accounts
                            *ngIf="accountGroup.data?.length > 1"
                            [dataElements]="dataElements"
                        ></sb-list-sub-accounts>
                    </ng-container>
                </ng-container>
            </ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="'child-account-balance-filtered'">
            <sb-list-sub-accounts
                *ngIf="dataElements?.length > 0"
                [dataElements]="dataElements"
            ></sb-list-sub-accounts>
        </ng-container>
        <ng-container *ngSwitchDefault>
            <div *ngIf="context.columnHeaders" class="sb-key-figure-advanced-item">
                <span
                    *ngFor="let column of context.columnHeaders"
                    class="sb-key-figure-cell-header"
                >
                    <span>{{ column.header }}</span>
                </span>
            </div>
            <ng-container
                *ngFor="
                    let element of dataElements;
                    let i = index;
                    trackBy: trackByFunction
                "
            >
                <div
                    *ngIf="element.hidden != true"
                    [ngClass]="{
                        'sb-last': i === dataElements.length - 1,
                        'sb-key-figure-advanced-item': true,
                        'routing-enabled': context.routingConfig
                    }"
                    (click)="onClick($event, context.routingConfig, element)"
                >
                    <span
                        [ngClass]="element.labelClass"
                        [ngStyle]="element.labelInlineStyle"
                    >
                        <span [ngClass]="getBulletCssClasses(element.key, element, i)">
                            <ng-container *ngIf="context.widgetId !== 'limit-alerts'">
                                {{ abbreviate(element.key) }}
                            </ng-container>
                        </span>
                    </span>
                    <ng-container
                        *ngFor="
                            let elementValue of element.values;
                            let i = index;
                            trackBy: trackByFunction
                        "
                    >
                        <div
                            *ngIf="elementValue.hidden != true"
                            [ngClass]="elementValue.valueClass"
                            [ngStyle]="elementValue.valueInlineStyle"
                        >
                            <app-sb-advanced-cell
                                [context]="context"
                                [value]="elementValue.value"
                                [columnConfiguration]="getColumnConfiguration()"
                                [defaultAlignment]="getDefaultAlignment(i)"
                            ></app-sb-advanced-cell>
                        </div>
                    </ng-container>
                </div>
            </ng-container>
        </ng-container>
    </ng-container>
</div>

<div *ngIf="context.layout === 'table'" class="sb-key-figure-advanced-wrapper">
    <div *ngIf="context.columnHeaders" class="sb-key-figure-advanced-item">
        <span
            *ngFor="let column of context.columnHeaders"
            class="sb-key-figure-cell-header"
        >
            <span>{{ column.header }}</span>
        </span>
    </div>
    <ng-container
        *ngFor="let element of dataElements; let i = index; trackBy: trackByFunction"
    >
        <div *ngIf="element.hidden != true">
            <ng-container
                *ngFor="let elementValue of element.values; trackBy: trackByFunction"
            >
                <div
                    *ngIf="elementValue.hidden != true"
                    class="sb-key-figure-advanced-item sb-key-figure-table-item"
                >
                    <div class="key-figure-cell-value">{{ elementValue.label }}</div>
                    <div [ngClass]="elementValue.valueClass">
                        {{ elementValue.value }}
                    </div>
                </div>
            </ng-container>
        </div>
    </ng-container>
</div>
